import {
  CustomerServiceFilled,
  DeliveredProcedureOutlined,
  GoldFilled,
  TruckFilled,
} from "@ant-design/icons";
import { Row } from "antd";

const HomeServices = () => {
  return (
    <Row>
      <div className="justify-around lg:flex w-full py-8">
        <div className="flex py-6 border-opacity-70 lg:w-[25%] max-lg:px-16 max-lg:border-b-2 lg:justify-center items-center home-service-section lg:border-e-2 border-[#D9D9D9]">
          {/* <FontAwesomeIcon
            icon={faTruckLoading}
            className="text-18 text-[#B91C1C]"
          /> */}
          <TruckFilled className="text-3xl text-[#B91C1C]" />
          <div className="ml-4 text-left">
            <h6 className="text-sm font-medium">Reliable Shipping</h6>
            <p className="text-xs">Delivery between 3-15 days</p>
          </div>
        </div>

        <div className="flex py-6 border-opacity-70 lg:w-[25%] max-lg:px-16 max-lg:border-b-2 lg:justify-center items-center home-service-section lg:border-e-2 border-[#D9D9D9]">
          <CustomerServiceFilled className="text-3xl text-[#B91C1C]" />
          <div className="ml-4 text-left">
            <h6 className="text-sm font-medium">Customer Support</h6>
            <p className="text-xs">Available 24/7</p>
          </div>
        </div>

        <div className="flex py-6 border-opacity-70 lg:w-[25%] max-lg:px-16 max-lg:border-b-2 lg:justify-center items-center home-service-section lg:border-e-2 border-[#D9D9D9]">
          <DeliveredProcedureOutlined className="text-3xl text-[#B91C1C]" />
          <div className="ml-4 text-left">
            <h6 className="text-sm font-medium">Fast Delivery</h6>
            <p className="text-xs">With Our Special Delivery Network</p>
          </div>
        </div>

        <div className="flex py-6 border-opacity-70 lg:w-[25%] max-lg:px-16 max-lg:border-b-2 lg:justify-center items-center home-service-section ">
          <GoldFilled className="text-3xl text-[#B91C1C]" />
          <div className="ml-4 text-left">
            <h6 className="text-sm font-medium">Wide choice</h6>
            <p className="text-xs">Over 5000 items available</p>
          </div>
        </div>
      </div>
    </Row>
  );
};

export default HomeServices;
